<div id="getting-started"></div>
<app-publicnavbar></app-publicnavbar>
<br>

<div class="container-fluid" style="word-break: break-word;">
  <div class="row">
      <div class="col-md-3">
        <div  style="position: fixed;" >
          
          <h3> Table of Contents</h3>
          <p-tree [value]="files1" scrollHeight="300px"  selectionMode="single"  (onNodeSelect)="nodeSelect($event.node)"></p-tree>
             
        </div>
          
      </div>
      <div class="col-md-9">
        <main role="main" class="container">
          <div class="row">
            <div id="parentDiv"    style="overflow-y: scroll;">
          
            <div class="col-md-12 blog-main">
              <br>
              
              <div class="h-100 p-5 bg-light border rounded-3">
            
             
          
              <div class="blog-post" id="GettingStarted_Overview">
              
                <div *ngIf="GettingStartedOverview">
                  <div  [innerHTML]="this.GettingStarted_Overview.properties.elements.main.value"></div> 
                  <hr class="hr-AEM">
                </div>
              </div>

              <div id="GettingStarted_CreateAnAccount" ></div>
              <div *ngIf="GettingStartedCreateAnAccount">
                  <div class="blog-post" >
                    
                    <div  [innerHTML]="this.GettingStarted_CreateAnAccount.properties.elements.main.value"></div> 
              
                    
                    
                  </div>

                  <hr class="hr-AEM">
              </div>

              <div id="sandboxapp" ></div>
                <div *ngIf="Creating_an_Application_SandboxApp">
                  <div class="blog-post" >
                    
                    <div  [innerHTML]="this.sandboxapp.properties.elements.main.value"></div> 

                    
                  </div>
                  <hr class="hr-AEM">
                </div>
              <div id="prodapp" ></div>
                <div *ngIf="Creating_an_Application_ProdAp">
                  <div class="blog-post" >
                    
                    <div  [innerHTML]="this.prodapp.properties.elements.main.value"></div> 

                    
                  </div>
                  <hr class="hr-AEM">
                </div>
              
               <div id="Authentication_Overview" ></div>
                <div *ngIf="authentication_overview">
                    <div class="blog-post" >
                      
                      <div  [innerHTML]="this.Authentication_Overview.properties.elements.main.value"></div> 

                      
                    </div>
                    <hr class="hr-AEM">
                </div>

              <div id="Authentication_Sandbox_APIs" ></div>
                <div *ngIf="authentication_sandbox_apis">
                    <div class="blog-post" >
                      
                      <div  [innerHTML]="this.Authentication_Sandbox_APIs.properties.elements.main.value"></div> 

                      
                    </div>
                    <hr class="hr-AEM">
                </div> 
              <div id="Authentication_Producation_APIs" ></div>
                <div *ngIf="authentication_production_apis">
                    <div class="blog-post" >
                      
                      <div  [innerHTML]="this.Authentication_Producation_APIs.properties.elements.main.value"></div> 

                      
                    </div>
                    <hr class="hr-AEM">
                </div>
              <div id="Authentication_Provider_Directory_Apis" ></div>
                <div *ngIf="authentication_provider_directory_apis">
                    <div class="blog-post" >
                      
                      <div  [innerHTML]="this.Authentication_Provider_Directory_Apis.properties.elements.main.value"></div> 

                      
                    </div>
                    <hr class="hr-AEM">
                </div>
     
                <div id="authentication_ehr_prod_apis_flag_div" ></div>
                <div *ngIf="authentication_ehr_prod_apis_flag">
                    <div class="blog-post" >
                      
                      <div  [innerHTML]="this.authentication_ehr_prod_apis_data.properties.elements.main.value"></div> 

                      
                    </div>
                    <hr class="hr-AEM">
                </div>


              <div id="swagger-info" ></div>
                <div *ngIf="swaggerInfo">
                    <div class="blog-post" >
                      
                      <div  [innerHTML]="this.swaggerinfo.properties.elements.main.value"></div> 

                      
                    </div>
                    <hr class="hr-AEM">
                </div>

              <div id="commonresponse-info" ></div>
                <div *ngIf="commonResponse">
                    <div class="blog-post" >
                      
                      <div  [innerHTML]="this.commonresponse.properties.elements.main.value"></div> 

                      
                    </div>
                  
                    <hr class="hr-AEM">
                </div>
              <div id="FAQ" ></div>
                <div *ngIf="faq">
                  <div class="blog-post" >
                    
                    <div  [innerHTML]="this.FAQ.properties.elements.main.value"></div> 

                    
                  </div>
                </div>

            </div> 
       
           
           
            </div>
        
          
          </div>
          </div>
        
        </main>

      </div>
  </div>    
</div>







 

 



   

 
